import React from "react";
import { Autocomplete } from "@material-ui/lab";
import { Checkbox, TextField } from "@material-ui/core";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

export function MultipleSelectAutocomplete({ value, setValue, mapOptions }) {
  console.log("mapOptions", mapOptions);
  const handleOnChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={mapOptions}
      disableCloseOnSelect
      getOptionLabel={option => option.testOrPanelName || ""}
      limitTags={4}
      size="small"
      value={value}
      onChange={handleOnChange}
      groupBy={option => option.panel === true ? "Panel" : "Individual Test"} 
      renderOption={(AVAILABLE_STATES_FULL, { selected }) => {
        return (
          <>
            <Checkbox
              icon={<CheckBoxOutlineBlank fontSize="small" />}
              checkedIcon={<CheckBox fontSize="small" />}
              style={{ marginRight: 8, height: "10px" }}
              checked={selected}
            />
            {AVAILABLE_STATES_FULL.testOrPanelName}
          </>
        );
      }}
      // style={{ width: }}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          label=""
          placeholder="Select Items"
          style={{
            backgroundColor: "white",
            width: "100%"
          }}
        />
      )}
    />
  );
}
